import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import "../index.css";

const DialogComponent = ({ activeId, closeModal, modalData }) => {
  if (modalData === undefined) return null;
  if (modalData.id === null) return null;

  return (
    <Dialog.Root open={activeId !== null} onOpenChange={closeModal}>
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay" />
        <Dialog.Content className="DialogContent !max-w-md">
          <div className="relative bg-[#D1DEDB] p-2.5 ">
            <Dialog.Close asChild>
              <button
                className="z-10 !border cursor-pointer bg-slate-800/20 text-slate-600 h-8 w-8 flex items-center justify-center rounded-full top-3 right-3 absolute pointer-cursor"
                aria-label="Close"
              >
                <Cross2Icon />
              </button>
            </Dialog.Close>

            <div className="bg-[#D1DEDB] p-4 md:p-8 relative flex flex-col justify-between min-h-[400px]">
              <div />
              <div>
                <Dialog.Title className="DialogTitle">
                  <span className="text-2xl font-semibold text-[#1c2e50] mb-4 block">
                    {modalData.title}
                  </span>
                </Dialog.Title>
                <Dialog.Description
                  style={{ maxWidth: "100%" }}
                  className="dark:prose-invert prose flex"
                >
                  {modalData.content}
                </Dialog.Description>
              </div>
              <div className="flex">
                {modalData?.link && (
                  <div className="flex pt-4 gap-3 items-center">
                    <a
                      href={modalData.link}
                      target="_parent"
                      className="flex rounded-full border border-[#1c2e50] px-4 py-1 no-underline hover:underline"
                    >
                      Read more
                    </a>
                    <span>
                      <span className="text-[#1c2e50] opacity-50">or</span>{" "}
                      <a
                        href="https://copenhagenoptimization.com/book-a-demo/"
                        target="_parent"
                        className="ml-1 font-normal opacity-90 hover:opacity-70"
                      >
                        book a demo
                      </a>
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default DialogComponent;
